export function getContentId(data, chosenData, code){
    if(data.enableProductOptions && chosenData && chosenData[code] && chosenData[code] != ""){
        return chosenData[code]
    }else if(data[code] && data[code] != ""){
        return data[code];
    }

    return data._id;
}

export function getContentIds(enableProductOptions, variations, fallbackSKU, onlyPurchased = true) {
    const skus = enableProductOptions && variations && variations.length
        ? variations
            .filter(vp => !onlyPurchased || vp.qty > 0)
            .map(vp => vp.SKU)
        : [];
    return skus.length > 0 ? skus : (fallbackSKU ? [fallbackSKU] : []);
}